import { DateTime } from 'luxon';

import aguid from 'lib/aguid';
import { buildShowGlobalGoal } from '../navigation/appRoutes';

const addedAsCollaboratorOfGoal = ({
  editorName,
  goal,
}: {
  editorName: string;
  goal: GeneralGoal;
}): Notifications.BasicNotification => ({
  id: aguid(),
  isBasic: true,
  type: 'ADDED_AS_COLLABORATOR_FOR_GOAL',
  seen: false,
  read: false,
  deleted: false,
  createdOn: DateTime.utc().toISO(),
  emailSent: false,
  link: buildShowGlobalGoal(goal.id),
  inAppSubject: `${editorName} added you as a Collaborator to the goal`,
  inAppBody: `${goal.title}`,
  inAppLinkText: 'View goal',
  emailSubject: `${editorName} added you as a Collaborator to a Goal on FleetOps`,
  emailBodyLn1: `${editorName} added you as a Collaborator to the goal - ${goal.title}`,
  emailBodyLn2: '',
  emailLinkText: 'Log in to view Goal Details',
});

export default addedAsCollaboratorOfGoal;
